// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"033ddc0a","163":"0721fc09","191":"9938ab8b","266":"9968117d","613":"97047547","829":"f19c80ae","896":"0b966540","925":"e7a307c1"}[chunkId] + ".chunk.js";
};